import React from 'react';
import HeroCarousel from '../components/HeroCarousel'; 
import ProductosDestacados from '../components/ProductosDestacados';
import HomeInfo from '../components/HomeInfo'

const Inicio = () => {
  return (
    <div>
      <HeroCarousel />
      <ProductosDestacados />
      <HomeInfo />
    </div>
  );
};

export default Inicio;